import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

type CardHeaderProps = {
  isLocked?: boolean
}

export const ILLUSTRATION_LOCKED_PATH =
  '/illustrations/img-padlock-lock-failed-access.png'
export const ILLUSTRATION_UNLOCKED_PATH =
  '/illustrations/img-assessment-indicator.png'

export function CardHeader({ isLocked = false }: CardHeaderProps) {
  return (
    <section className="flex space-x-6 p-6 items-start">
      <div className="flex-shrink-0">
        <img
          alt=""
          src={assetUrl(
            isLocked ? ILLUSTRATION_LOCKED_PATH : ILLUSTRATION_UNLOCKED_PATH
          )}
          width={84}
          height={84}
        />
      </div>

      <div className="max-w-3xl flex flex-col gap-1 self-stretch justify-center">
        <Text variant="heading-lg" as="h3">
          Pelaksanaan Kinerja
        </Text>
        <Text color="subdued">Laksanakan berdasarkan Perencanaan Anda.</Text>
      </div>
    </section>
  )
}
